import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import Profile from "@/components/user/ProfileComponent.vue";
import TermsOfUse from "@/components/terms/TermsOfUseComponent.vue";
import TermsOfSales from "@/components/terms/TermsOfSalesComponent.vue";
import { request } from "@/js/http/http_request";
export default {
  name: "acceptTerms",
  components: {
    TermsOfUse: TermsOfUse,
    TermsOfSales: TermsOfSales,
    Profile: Profile
  },
  data: function data() {
    return {
      step: 1,
      isAccepting: false,
      isFirstConnection: false,
      hasScrolledToBottom: false
    };
  },
  created: function created() {
    this.isFirstConnection = !!this.$route.query.is_first_connection;
  },
  methods: {
    handleScroll: function handleScroll(el) {
      this.hasScrolledToBottom = el.srcElement.offsetHeight + el.srcElement.scrollTop >= el.srcElement.scrollHeight - 10;
    },
    accept: function accept() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.step === 2)) {
                _context.next = 9;
                break;
              }
              _this.isAccepting = true;
              _context.next = 4;
              return request("/v1/users/terms/accept", "post", null, true, "api");
            case 4:
              response = _context.sent;
              _this.isAccepting = false;
              if (response.status === 200) {
                if (_this.isFirstConnection) _this.step++;else _this.$router.push({
                  name: "userHome"
                });
              }
              _context.next = 11;
              break;
            case 9:
              _this.step++;
              _this.hasScrolledToBottom = false;
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};